import { BrowserRouter as Router } from 'react-router-dom';

import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { wixAxiosConfig } from '@wix/wix-axios-config';
import App from './components/App';
import { create as createFedopsLogger } from '@wix/fedops-logger';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';

import thunkMiddleware from 'redux-thunk';

import settingsReducer from './components/settings/reducers/settingsReducer';

import { ExperimentsProvider } from '@wix/wix-experiments-react';
import { loadGAEditorSDK } from '@wix/platform-editor-sdk/lib/loader';
import { EditorSDKProvider } from './context/EditorSDKContext';
import { applicationLoaded } from './utils';

const baseURL = window.__BASEURL__;
const experiments = window.EXPERIMENTS;

wixAxiosConfig(axios, { baseURL });

const fedopsLogger = createFedopsLogger('yoshi-calendar');

fedopsLogger.appLoaded();

applicationLoaded();

const initialState = window.REDUX_STATE;
const store = createStore(
  settingsReducer,
  initialState,
  applyMiddleware(thunkMiddleware),
);

console.log('experiments = ', experiments);

loadGAEditorSDK()
  .then((editorSDK) => {
    ReactDOM.render(
      <React.Suspense fallback={<div>Please wait...</div>}>
        <Router store={store}>
          <Provider store={store}>
            <ExperimentsProvider options={{ experiments }}>
              <EditorSDKProvider value={editorSDK}>
                <App initialState={window.INITIAL_STATE} />
              </EditorSDKProvider>
            </ExperimentsProvider>
          </Provider>
        </Router>
      </React.Suspense>,
      document.getElementById('root'),
    );
  })
  .catch((e) => console.log('>>> loadGAEditorSDK error, ', e));
